<template>
  <b-card>
    <b-form @reset="resetFilter">
      <fieldset :disabled="loading">
        <b-form-group id="orderStatus-group" :label="$t('status')" label-for="orderStatus">
          <b-form-select size="sm" id="orderStatus" v-model="filter.orderStatus" :options="orderStatuses" @change="updateOrders">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="orderId-group" :label="$t('orderId')" label-for="orderId">
          <b-form-input size="sm" id="orderId" type="text" v-model="filter.orderId" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="source-group" :label="$t('source')" label-for="source">
          <b-form-select size="sm" id="source" v-model="filter.source" :options="orderSources" v-on:change="updateOrders">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="customer-group" :label="$t('customer')" label-for="customer">
          <b-form-input size="sm" id="customer" type="text" v-model="filter.customer" :disabled=isActiveProfileSet v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="buyer-group" :label="$t('buyer')" label-for="buyer">
          <b-form-input size="sm" id="buyer" type="text" v-model="filter.buyer" v-on:keyup="onKeyup"/>
        </b-form-group>

        <label for="fromDate">{{ $t('from') }}</label>
        <b-form-datepicker size="sm" id="fromDate" class="mb-2" reset-button locale="langCode" :label-reset-button="$t('reset')"
                           reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.fromDate"/>

        <label for="toDate">{{ $t('to') }}</label>
        <b-form-datepicker size="sm" id="toDate" class="mb-4" reset-button locale="langCode" :label-reset-button="$t('reset')"
                           reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.toDate"/>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" type="reset" class="float-right">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>

      </fieldset>
    </b-form>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrderFilter',
    extends: BaseComponent,

    computed: {
      ...mapGetters('orders', ['filter', 'paging', 'loading']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet','activeProfile']),
      orderStatuses () {
        return [
          { value: 'NEW', text: this.$t('constants.NEW') },
          { value: 'REJECTED', text: this.$t('constants.REJECTED') },
          { value: 'FULFILLED', text: this.$t('constants.FULFILLED') },
          { value: 'FINISHED', text: this.$t('constants.FINISHED') }
        ]
      }
    },

    methods: {
      resetFilter () {
        this.$store.dispatch('orders/resetFilter')
        this.updateOrders()
      },

      onKeyup (event) {
        if (event.which === 13) {
          this.updateOrders()
        }
      },

      updateOrders () {
        this.$store.dispatch('orders/getOrders')
      }
    },

    watch: {
      'paging.perPage': function () {
        this.updateOrders()
      },
      'paging.currentPage': function () {
        this.updateOrders()
      },
      'filter.fromDate': function () {
        this.updateOrders()
      },
      'filter.toDate': function () {
        this.updateOrders()
      },
      'isActiveProfileSet': function () {
        this.updateOrders()
      }
    }
  }
</script>
